import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Battery = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="-2 0 22 20"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <path
      d="M17.084 7.91699C18.334 7.91699 18.334 8.33366 18.334 9.16699V10.8337C18.334 11.667 18.334 12.0837 17.084 12.0837"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.31641 8.33301C5.59141 9.42467 5.59141 10.5747 5.31641 11.6663"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.23242 8.33301C8.50742 9.42467 8.50742 10.5747 8.23242 11.6663"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 8.33301C11.275 9.42467 11.275 10.5747 11 11.6663"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8327 15.8337H5.83268C2.49935 15.8337 1.66602 15.0003 1.66602 11.667V8.33366C1.66602 5.00033 2.49935 4.16699 5.83268 4.16699H10.8327C14.166 4.16699 14.9993 5.00033 14.9993 8.33366V11.667C14.9993 15.0003 14.166 15.8337 10.8327 15.8337Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
